// ─── Shared merge-tag preview UI ────────────────────────────────────────────
//
// Before this file existed, "who am I currently previewing this email as"
// was answered three separate, inconsistent ways:
//   1. Mail Merge's main Live Preview navigator — real loaded recipients,
//      paginated (First/Prev/Next/Last), driven by previewIdx state.
//   2. MailMergeEmailEditor's own popup preview — received the exact same
//      `recipients` array as a prop, but only ever rendered recipients[0]
//      with no way to page to anyone else, even though the data to do so
//      was sitting right there.
//   3. SubjectRotationPanel's preview — has no recipient list at all (it's
//      testing abstract subject-line variants, not sending to anyone yet),
//      so it always showed a hardcoded dummy contact with its own
//      one-off badge styling.
//
// One shared component now backs all three: same "Previewing / Sample
// preview: NAME, Company" badge, same First/Prev/Next/Last control styling
// when there's a real list to page through (navigable=true), and the same
// dummy contact shape when there isn't (navigable=false, dummy=true) — so
// the three surfaces read as one system instead of three different ideas
// of what a preview looks like.

export const DUMMY_PREVIEW_CONTACT = { firstName: "Alex", lastName: "Rivera", first: "Alex", last: "Rivera", name: "Alex Rivera", company: "Acme Corp", title: "VP Sales", email: "alex@acme.com" };
export const DUMMY_PREVIEW_SENDER = { sdrName: "Jordan Lee", company: "SDR ReachOut" };

function navBtnStyle(C, disabled) {
  return { background: "none", border: "1px solid " + (C.border || "#d1cec9"), borderRadius: 2, padding: "2px 6px", cursor: disabled ? "not-allowed" : "pointer", fontSize: 11, opacity: disabled ? 0.4 : 1, color: C.text || "#201f1e", lineHeight: 1 };
}

export default function MergePreviewBar({ recipient, index = 0, total = 1, navigable = false, dummy = false, onFirst, onPrev, onNext, onLast, theme, compact = false }) {
  const C = theme || {};
  const name = recipient
    ? (recipient.name || [recipient.firstName || recipient.first, recipient.lastName || recipient.last].filter(Boolean).join(" ") || recipient.email || "(no name)")
    : "(no recipient)";
  const atStart = index <= 0;
  const atEnd = index >= total - 1;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
      <span style={{ fontSize: compact ? 10 : 11, fontWeight: 600, color: C.accent || "#0078d4", background: C.accentL || "#deecf9", padding: compact ? "1px 6px" : "2px 8px", borderRadius: 3, whiteSpace: "nowrap" }}>
        {dummy ? "Sample preview — " : "Previewing — "}{name}{recipient?.company ? ", " + recipient.company : ""}
      </span>
      {navigable && (
        <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
          <button onClick={onFirst} disabled={atStart} title="First recipient" style={navBtnStyle(C, atStart)}>&#8676;</button>
          <button onClick={onPrev} disabled={atStart} title="Previous recipient" style={navBtnStyle(C, atStart)}>&#9664;</button>
          <span style={{ fontSize: 11, color: C.textMuted || "#a19f9d", minWidth: 46, textAlign: "center" }}>{total ? index + 1 : 0} of {total}</span>
          <button onClick={onNext} disabled={atEnd} title="Next recipient" style={navBtnStyle(C, atEnd)}>&#9654;</button>
          <button onClick={onLast} disabled={atEnd} title="Last recipient" style={navBtnStyle(C, atEnd)}>&#8677;</button>
        </div>
      )}
    </div>
  );
}
